/* VIVA63 RGB scrollytelling — one desktop wheel gesture advances one media
   card and centres it in the viewport. Non-active cards remain in normal
   document flow and are rendered slightly smaller. */
(function () {
  'use strict';

  var MQ_DESKTOP = window.matchMedia('(min-width: 750px)');
  var MQ_REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (root.dataset.vivaRgbReady) return;
    root.dataset.vivaRgbReady = '1';

    var scroller = root.querySelector('.viva-rgb__scroller');
    var medias = Array.prototype.slice.call(root.querySelectorAll('[data-viva-rgb-media]'));
    var labels = Array.prototype.slice.call(root.querySelectorAll('[data-viva-rgb-label]'));
    var bodies = Array.prototype.slice.call(root.querySelectorAll('[data-viva-rgb-body]'));
    if (!scroller || medias.length < 2) return;

    var active = 0;
    var ticking = false;
    var wheelLocked = false;
    var wheelTimer = 0;
    var wheelLockUntil = 0;
    var frame = 0;

    function activate(i) {
      if (i === active) return;
      active = i;
      medias.forEach(function (m, idx) { m.classList.toggle('is-active', idx === i); });
      labels.forEach(function (l, idx) { l.classList.toggle('is-active', idx === i); });
      bodies.forEach(function (b, idx) { b.classList.toggle('is-active', idx === i); });
    }

    function nearestToViewportCentre() {
      var mid = window.innerHeight / 2;
      var best = 0;
      var bestD = Infinity;

      medias.forEach(function (media, i) {
        var rect = media.getBoundingClientRect();
        var distance = Math.abs(rect.top + rect.height / 2 - mid);
        if (distance < bestD) {
          bestD = distance;
          best = i;
        }
      });

      return best;
    }

    function update() {
      ticking = false;
      if (!MQ_DESKTOP.matches) return;
      if (!wheelLocked) activate(nearestToViewportCentre());
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      frame = window.requestAnimationFrame(update);
    }

    function centreMedia(index) {
      var rect = medias[index].getBoundingClientRect();
      var targetTop = window.scrollY + rect.top + rect.height / 2 - window.innerHeight / 2;

      activate(index);
      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: MQ_REDUCED_MOTION.matches ? 'auto' : 'smooth'
      });
    }

    function releaseWheel() {
      wheelLocked = false;
      update();
    }

    function onWheel(event) {
      if (!MQ_DESKTOP.matches || event.ctrlKey) return;
      if (Math.abs(event.deltaY) <= Math.abs(event.deltaX) || Math.abs(event.deltaY) < 4) return;

      var scrollerRect = scroller.getBoundingClientRect();
      var viewportMid = window.innerHeight / 2;
      if (scrollerRect.top > viewportMid || scrollerRect.bottom < viewportMid) return;

      var activeRect = medias[active].getBoundingClientRect();
      var activeMid = activeRect.top + activeRect.height / 2;
      var captureRange = Math.max(160, window.innerHeight * 0.35);
      if (Math.abs(activeMid - viewportMid) > captureRange) return;

      if (wheelLocked) {
        event.preventDefault();
        window.clearTimeout(wheelTimer);
        wheelTimer = window.setTimeout(
          releaseWheel,
          Math.max(180, wheelLockUntil - window.performance.now())
        );
        return;
      }

      var direction = event.deltaY > 0 ? 1 : -1;
      var next = active + direction;

      /* At either end, release the wheel so the visitor can continue through
         the rest of the page without becoming trapped in the component. */
      if (next < 0 || next >= medias.length) return;

      event.preventDefault();
      wheelLocked = true;
      wheelLockUntil = window.performance.now() + (MQ_REDUCED_MOTION.matches ? 80 : 720);
      window.clearTimeout(wheelTimer);
      centreMedia(next);
      wheelTimer = window.setTimeout(
        releaseWheel,
        Math.max(80, wheelLockUntil - window.performance.now())
      );
    }

    function destroy() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      scroller.removeEventListener('wheel', onWheel);
      window.clearTimeout(wheelTimer);
      window.cancelAnimationFrame(frame);
      delete root.dataset.vivaRgbReady;
      delete root.vivaRgbDestroy;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    scroller.addEventListener('wheel', onWheel, { passive: false });
    root.vivaRgbDestroy = destroy;
    update();
  }

  function boot() {
    document.querySelectorAll('[data-viva-rgb]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-viva-rgb]');
    if (root && root.vivaRgbDestroy) root.vivaRgbDestroy();
  });
})();
